import { ResourceProps } from "ra-core";
import { FC } from "react";
import { SupportedResources } from "@/dataProvider/tools";
import { useResourceRegister } from "@/utils/resourceRegister";

const noop: SupportedResources = 'noop'
const networkConnections: SupportedResources = 'network-connections'
const settingsEncryptKeyAssign: SupportedResources = 'settings-encrypt-key-assign'
const govrncDataTablesOwnership: SupportedResources = 'govrnc-data-ownership'

const Registration: FC = () => {
  // this component is meant to serve as an entry point for resource registration.
  // those resources are not registered with route are relatively short-lived;
  // but if we want to extend their lifetime, we can register them here:
  useResourceRegister({ name: noop })
  useResourceRegister({ name: networkConnections })
  useResourceRegister({ name: settingsEncryptKeyAssign })
  useResourceRegister({ name: govrncDataTablesOwnership })
  useResourceRegister({ name: 'device-consent' })
  useResourceRegister({ name: 'token-validation-keys' })
  useResourceRegister({ name: 'token-validation-key-regenerate' })
  useResourceRegister({ name: 'encrypted-dbs' })
  useResourceRegister({ name: 'db-esc-status' })
  useResourceRegister({ name: 'encrypt-setting-changes' })
  useResourceRegister({ name: 'table-rename-hint' })
  useResourceRegister({ name: 'file-encrypt-template' })
  useResourceRegister({ name: 'file-encrypt-rule-map' })
  useResourceRegister({ name: 'settings-obfs-rule-upload' })
  useResourceRegister({ name: 'subset-tablerefs' })
  useResourceRegister({ name: 'subset-database-default-limit' })
  
  return null;
}

const RegistrationOnlyResource: FC<ResourceProps> = ({ intent }) => {
  if (intent === 'registration') {
    return <Registration />
  }
  return null
}

export default RegistrationOnlyResource;
